module.exports = __webpack_public_path__ + "static/media/test.02309141.md";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Markdown/test.md
// module id = 220
// module chunks = 0